import Vue from 'vue'
import Vuex from 'vuex'
import mutations from "@/apps/NavigationWidget/store/mutations";
import getters from "@/apps/NavigationWidget/store/getters";
import {root} from "@/shared/store";
import {NavigationWidgetState} from "@/apps/NavigationWidget/model/navigation-widget-state";

Vue.use(Vuex)

export default new Vuex.Store({
    state: new NavigationWidgetState(),
    mutations: mutations,
    getters: getters,
    modules: {
        root
    }
})

